import { useContextSelector } from 'use-context-selector';
import { UserStateContext } from '../context/UserContext/UserContext';

export const useDashboardById = (id: string) => {
  return useContextSelector(UserStateContext, (v) =>
    v?.state.dashboards.find((dashboard) => dashboard.id === id)
  );
};
